<template>
  <section class="page-home desk-frame">
    <!-- desktop view -->
    <template v-if="!isMobile">
      <header-desktop />
      <menu-desktop />
      <calendar-desktop
        v-if="$route.name === 'calendar'"
        :events="filteredEvents"
        :smallCalEvents="smallCalEvents"
        @initCalendarDesktop="initCalendarDesktop"
      />
      <surgeries-desktop
        v-else-if="$route.name === 'surgeries'"
        :events="filteredEvents"
        :smallCalEvents="smallCalEvents"
        :showSaveSurgeriesButton="showSaveSurgeriesButton"
        @initCalendarDesktop="initCalendarDesktop"
        @setShowSaveSurgeriesButton="setShowSaveSurgeriesButton"
      />
      <home-desktop
        v-else
        :timeFrom="timeFrom"
        :timeTo="timeTo"
        :events="filteredEvents"
        :smallCalEvents="smallCalEvents"
        @initCalendarDesktop="initCalendarDesktop"
        @editBlock="editBlock"
        @deleteBlock="deleteBlock"
        @disableBlock="disableBlock"
        @activateBlock="activateBlock"
      />
    </template>
    <!-- /desktop view -->
    <!-- mobile view -->
    <div class="calandr_main mobile_only" v-show="!isShowSearch">
      <div id="app">
        <CalendarPopup
          v-if="isCalendarPopup"
          @change-date="ev => dateChange(ev, true)"
        />
        <days-slider
          v-if="currentView == 'day'"
          :current-date="currentDate"
          :blocks="$route.name == 'surgeries' ? allBlocks : filteredEvents"
          :isRoom="isRoom"
          :showAppointment="showAppointment"
          :onlyEvents="onlyEvents"
          @change-date="dateChange"
          @go-back="sliderChangeView"
          @selected_room="changeRoom"
          @toggleShowAppointment="ev => (showAppointment = ev)"
          @setMobiscrollEvents="() => SET_MOBISCROLL_EVENTS(events)"
        ></days-slider>
        <vue-cal
          v-if="isCalendar && filteredEvents"
          class="vuecal--rounded-theme vuecal--green-theme"
          :xsmall="true"
          ref="vuecal"
          :active-view="currentView"
          locale="he"
          :timeFrom="timeFrom"
          :timeCellHeight="80"
          :timeTo="timeTo"
          :timeStep="timeStep"
          :clickToNavigate="true"
          hide-view-selector
          :eventsCountOnYearView="true"
          :time="true"
          :selected-date="currentDate"
          :hide-body="hideBody"
          :hide-title-bar="hideTitleBar"
          :startWeekOnSunday="true"
          default-view="month"
          :disable-views="['years', 'week']"
          :on-event-click="onEventClick"
          @cell-click="onCellClick"
          :events="filteredEvents"
          @view-change="viewChange"
        >
          <template v-slot:weekday-heading="{ heading }">
            <span v-if="heading.label == 'ראשון'">א׳</span>
            <span v-if="heading.label == 'שני'">ב׳</span>
            <span v-if="heading.label == 'שלישי'">ג׳</span>
            <span v-if="heading.label == 'רביעי'">ד׳</span>
            <span v-if="heading.label == 'חמישי'">ה׳</span>
            <span v-if="heading.label == 'שישי'">ו׳</span>
            <span v-if="heading.label == 'שבת'">ש׳</span>
          </template>
          <!-- Custom cells -->
          <template v-slot:event="{ event }">
            <div :class="{ 'event-container': event.type !== 'block' }">
              <button
                v-if="event.type === 'surgery'"
                class="nav-dots flex flex--end"
              >
                <span class="nav-dot"></span>
              </button>
              <SurgDotsMenu
                v-click-outside="ev => hideEditBlock(event, ev)"
                v-if="event.bg_menu && event.type === 'surgery'"
                :event="event"
                :isSelectedDatePassed="isSelectedDatePassed"
              />
              <div
                v-if="
                  !event.is_pending &&
                    ((event.type == 'block' && !showAppointment) ||
                      (event.type != 'block' && showAppointment))
                "
                class="vuecal__event-title"
                :class="{
                  'has-icon-by': event.type == 'appointment',
                  'title-add-padd':
                    event.background &&
                    !showAppointment &&
                    !isSelectedDatePassed
                }"
                v-html="event.content"
              ></div>
            </div>

            <div
              v-if="
                event.type === 'block' &&
                  event.is_pending &&
                  $route.name == 'surgeries'
              "
            >
              <div class="pending-title">ממתין לאישור מוקד הניתוחים</div>
            </div>

            <button
              class="block-edit-btn"
              v-if="
                event.background && !showAppointment && !isSelectedDatePassed
              "
              @click="event.bg_menu = !event.bg_menu"
            >
              עריכה
            </button>
            <div
              class="open-nav-dots"
              v-if="event.background && event.bg_menu && !showAppointment"
            >
              <div
                class="row flex flex--end block_action"
                @click="editBlock(event)"
              >
                <span>עדכון שעות הבלוק</span>
                <Clock />
              </div>
              <div
                class="row flex flex--end block_action"
                @click="deleteBlock(event)"
              >
                <span>מחיקת בלוק מרפאה</span>
                <Trash />
              </div>
              <div
                class="row flex flex--end block_action"
                @click="disableBlock(event)"
                v-if="!event.is_private"
              >
                <span>חסום זימון דיגיטלי</span>
                <Blocked />
              </div>
              <div
                class="row flex flex--end block_action"
                @click="activateBlock(event)"
                v-else
              >
                <span>הפעל זימון דיגיטלי</span>
                <Blocked />
              </div>
            </div>
            <!-- Or if your events are editable: -->
          </template>
          <template v-slot:cell-content="{ cell, view, events }">
            <span class="vuecal__cell-date">{{ cell.content }}</span>

            <span
              class="vuecal__cell-events-count"
              :class="{ hide: !showAppointment || events.length === 0 }"
              v-if="['month'].includes(view.id)"
            >
              {{ countAppointments(events) }}
            </span>
          </template>
        </vue-cal>

        <!-- Mobile drag & drop -->
        <scheduler
          v-if="isMobileDragDrop"
          @toggleShowAppointment="ev => (showAppointment = ev)"
        />

        <!-- app list -->
        <div class="events-only" v-if="isOnlyList && $route.name == 'list'">
          <div class="no-events" v-if="!hasEvents(onlyEvents, currentDate)">
            אין אירועים
          </div>
          <template v-for="(item, index) in onlyEvents">
            <div
              v-if="compareDate(item.start, currentDate)"
              class="vuecal__event appointmentBlock"
              :key="index + '-' + item.id"
              @click="onEventClick(item, $event)"
            >
              <div
                class="vuecal__event-title"
                :class="{ 'has-icon-by': item.type == 'appointment' }"
                v-html="item.content"
              ></div>
            </div>
          </template>
        </div>
        <!-- surg list -->
        <surgery-list
          v-if="isOnlyList && $route.name == 'surgeries-list'"
          :isMobile="true"
          :surgeryList="surgeryList"
        />
      </div>
    </div>
    <!-- /mobile view -->
  </section>
</template>

<script>
import VueCal from "vue-cal";
import "vue-cal/dist/i18n/he.es.js";
import "vue-cal/dist/vuecal.css";
import DaysSlider from "./DaysSlider";
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import Clock from "../../assets/img/svg/clock1.svg";
import Trash from "../../assets/img/svg/trash-black.svg";
import Blocked from "../../assets/img/svg/blocked.svg";
import ConfirmDisableBlock from "@/components/Popups/ConfirmDisableBlock";
import HeaderDesktop from "../Shared/HeaderDesktop.vue";
import MenuDesktop from "@/components/Shared/MenuDesktop.vue";
import HomeDesktop from "@/components/Dashboard/HomeDesktop/HomeDesktop.vue";
import ConfirmActivateBlock from "@/components/Popups/ConfirmActivateBlock";
import CalendarDesktop from "./CalendarDesktop.vue";
import SurgeriesDesktop from "@/components/Dashboard/Surgery/SurgeriesDesktop";
import BlockEditInvalidPop from "@/components/Popups/BlockEditInvalid";
import Error from "@/components/Popups/Error";
import UnsavedChangesAlert from "@/components/Popups/UnsavedChangesAlert";
import Whatsapp from "@/components/Popups/Whatsapp.vue";
import EnterPop from "@/components/Popups/EnterPop";
import SurgeryList from "@/components/Dashboard/List/SurgeryList";
import Scheduler from "@/components/Mobiscroll/Scheduler.vue";
import CancelPop from "../Popups/CancelApp";
import SurgDotsMenu from "./Surgery/SurgDotsMenu.vue";
import ClickOutside from "vue-click-outside";
import SMSToPatient from "../Popups/SMSToPatient.vue";
import {
  compareDate,
  isDateInRange,
  parseDay,
  isDatePassed,
  getDuration,
  getDate
} from "../../utilities/dates.js";
import {
  buildAppointmentEvent,
  buildBlockEvent,
  buildSurgeryEvent,
  getEventsType
} from "../../utilities/build-type-event.js";
import { getHash } from "../../utilities/hash.js";
import { backClickTimeout } from "../../utilities/globals";
import {
  getInitPopup,
  getSurgeryErrorPopup
} from "../../utilities/get-init-popup";
import CalendarPopup from "../Mobiscroll/CalendarPopup.vue";
import AddDocuments from "@/components/Popups/AddDocuments";

export default {
  name: "Home",
  directives: {
    ClickOutside
  },
  data() {
    return {
      events: [], // main events
      smallCalEvents: [], // events for small calendar - desktop
      blocks: [],
      currentDate: new Date(),
      hideBody: false,
      onlyEvents: [], // without block type events
      hideTitleBar: false,
      hideViewSelector: false,
      currentView: "month",
      allBlocks: [], // api response of fullcalendar_events_ajax
      headerEvent: false,
      timeFrom_start: 0 * 60,
      timeTo_start: 24 * 60,
      none_scheduled_surgeries: [],
      isRoom: false,
      showSaveSurgeriesButton: false,
      showAppointment: true,
      calendarInterval: null // store interval ID for cleanup
    };
  },
  async mounted() {
    sessionStorage.removeItem("temp_surgery");
    // reset edit app
    this.SET_APP_TIME_EDIT(null);
    // Check if appointment lock & reset
    const appointmentLock = localStorage.getItem("appointmentLock");
    if (appointmentLock) {
      await this.$API.appointmentAbortLock(appointmentLock);
      localStorage.removeItem("appointmentLock");
    }
    // Setup date & view
    const hasView =
      typeof this.hashData !== "undefined" && this.hashData
        ? this.hashData.view
        : false;
    if (hasView) {
      this.currentView = this.hashData.view;
      this.currentDate = new Date(this.hashData.date);
      if (this.isMobile) {
        this.initCalendar(
          this.$store.getters.activeDoctor.id,
          this.currentDate,
          true
        );
        this.$refs.vuecal.switchView(this.currentView);
      }
    }
    // for מבט על
    if (this.isMobile) {
      if (this.$route.name == "calendar") this.hideTitleBar = true;
      else this.hideTitleBar = false;
    }
    // option by route name
    switch (this.$route.name) {
      case "calendar":
      case "Dashboard":
        if (!hasView) this.currentView = "month";
        break;
      case "list":
      case "surgeries-list":
      case "surg-app-list":
        if ((!hasView && this.isMobile) || !this.isMobile) {
          this.currentView = "month";
        }
        break;
    }
    // only for mobile get events
    if (!hasView && this.isMobile) {
      this.initCalendar(
        this.$store.getters.activeDoctor.id,
        this.currentDate,
        true
      );
    }
    // Get rooms
    this.$API.getTypehead("rooms").then(res => this.SET_ALL_ROOMS(res));
    this.$root.$on("refreshBlock", () => {
      this.initCalendar(
        this.$store.getters.activeDoctor.id,
        this.currentDate,
        true,
        "both"
      );
    });
    // listen to reschedule surgery
    this.$root.$on("rescheduleSurgery", () => {
      const isMobile = window.innerWidth < 1200;
      if (!isMobile) return;
      this.initCalendar(this.activeDoctor.id, this.currentDate, true);
    });
    // Get events interval
    this.calendarInterval = setInterval(() => {
      if (this.showSaveSurgeriesButton || this.$route.name == "app-add") return;
      const date =
        this.hashData && this.hashData.date
          ? new Date(this.hashData.date)
          : this.currentDate;
      this.initCalendar(this.$store.getters.activeDoctor.id, date, true);
    }, 1000 * 60 * 2);
    setTimeout(() => {
      if (this.hashData && this.hashData.blockId) {
        const filteredEvents = this.events.filter(
          ev => ev.id == this.hashData.blockId
        );
        if (filteredEvents && filteredEvents.length) {
          this.deleteBlock(filteredEvents[0]);
        } else {
          window.location.hash = getHash({ blockId: "" });
        }
      }
    }, backClickTimeout());
  },
  watch: {
    $route(to, from) {
      const isMobile = window.innerWidth < 1200;
      // Mobiscroll
      if (to.hash !== from.hash && isMobile) {
        if (this.hashData.view == "month") {
          this.TOGGLE_MOBISCROLL(false);
          this.hashDataToStorage();
          this.$refs.vuecal.switchView("month");
        }
      }
      if (to.name != "Dashboard") this.TOGGLE_MOBISCROLL(false);

      this.hideBody = false;
      // route options
      switch (to.name) {
        case "calendar":
          this.hideTitleBar = true;
          this.showCalBody();
          break;
        case "Dashboard":
          this.hideTitleBar = false;
          this.showCalBody();
          break;
      }
      // get events
      if (
        to.path.includes("dashboard") &&
        from.path.includes("dashboard") &&
        to.name !== from.name
      ) {
        if (isMobile) {
          this.currentDate = new Date();
          this.currentView = "month";
          this.$refs.vuecal.switchView("month");
        }
        this.initCalendar(this.activeDoctor.id, this.currentDate, true);
      }
    },
    activeDoctor: function(newvalue, oldvalue) {
      if (typeof newvalue.id != "undefined" && newvalue.id != oldvalue.id) {
        this.initCalendar(newvalue.id, this.currentDate, true, "");
      }
    },
    currentView(value, oldvalue) {
      if (value == "month" || value == "year") {
        this.initCalendar(this.activeDoctor.id, this.currentDate);
      }
      if (this.isMobile) {
        window.location.hash = getHash({
          date: this.currentDate.format("YYYY-MM-DD"),
          view: value
        });
        this.hashDataToStorage();
      }
    },
    currentDate(currentDate, oldDate) {
      const newDate = this.$moment(currentDate);
      window.location.hash = getHash({
        date: newDate.format("YYYY-MM-DD"),
        view: this.currentView
      });
      if (this.isMobile) this.hashDataToStorage();
    },
    isSurgSchedule(val) {
      if (val) {
        this.initCalendar(this.activeDoctor.id, this.currentDate, true);
        this.SET_IS_SURG_SCHEDULE(false);
      }
    }
  },
  methods: {
    ...mapActions(["SET_ALL_ROOMS"]),
    ...mapMutations([
      "SET_IS_SURG_SCHEDULE",
      "SET_APP_TIME_EDIT",
      "SET_MOBISCROLL_EVENTS",
      "SET_MOBISCROLL_DATE",
      "TOGGLE_MOBISCROLL",
      "SET_INITIAL_TAB",
      "UPDATE_EVENTS_TO_SAVE"
    ]),
    // utils functions - need for vue template
    compareDate,
    isDatePassed,
    getDuration,
    getDate,
    /**
     * counts events for a day by route
     * MOBILE function - for month view
     * @param {Array} events
     * @returns {Number}
     */
    countAppointments(events) {
      if (
        this.$route.name == "surgeries" ||
        this.$route.name == "surgeries-list"
      ) {
        return events ? events.filter(e => e.type === "surgery").length : 0;
      } else if (this.$route.name == "surg-app-list") {
        return events.length;
      }
      return events ? events.filter(e => e.type === "appointment").length : 0;
    },
    /**
     * trigger by click on event in month view
     * MOBILE function
     * @param {Object} event
     * update current date
     */
    onCellClick(event) {
      if (!event) return;
      // check if event date is correct - vue cal bug send wrong event
      const eventDate = this.$moment(event).format("YYYY-MM-DD");
      let index = 0;
      let yesterday;
      if (this.currentView != "year") {
        index = this.filteredEvents.findIndex(
          e => this.$moment(e.start).format("YYYY-MM-DD") == eventDate
        );
        if (index == -1) {
          yesterday = this.$moment(eventDate, "YYYY-MM-DD").subtract(1, "days");
        }
      }
      // update current date
      this.currentDate = index == -1 ? new Date(yesterday) : event;
      this.SET_MOBISCROLL_DATE(this.currentDate);
      getHash({ date: this.$moment(this.currentDate).format("YYYY-MM-DD") });
    },
    /**
     * Hide dots menu
     * @param {Object} ev
     * @param {MouseClickEvent} event
     */
    hideEditBlock(ev, event) {
      if (!event) return;
      if (
        event.target.className.includes("nav-dots") ||
        event.target.className.includes("nav-dot")
      )
        return;
      const index = this.filteredEvents.findIndex(event => event.id === ev.id);
      this.filteredEvents[index].bg_menu = false;
    },
    /**
     * trigger by click on event in day view
     * MOBILE function
     * @param {Object} event
     * change route / reschedule surg
     */
    onEventClick(event, e) {
      const classList = [...e.target.classList];
      /// Open dot-menu
      if (classList.includes("nav-dots") || classList.includes("nav-dot")) {
        const index = this.filteredEvents.findIndex(i => i.id === event.id);
        const bgMenuIsFalse = !this.filteredEvents[index].bg_menu;
        this.filteredEvents.forEach(event => (event.bg_menu = false));
        if (bgMenuIsFalse) {
          this.filteredEvents[index].bg_menu = !this.filteredEvents[index]
            .bg_menu;
        }
        return;
      }
      // Clicked to cellosign
      if (classList.includes("cellosign-btn")) {
        this.$router.push(`/cellosign/?surgId=${event.id}`);
        return;
      }
      /// Clicked to reschedule
      if (
        classList.includes("scheduling-svg") ||
        classList.includes("resched-btn")
      ) {
        this.cancelSurg(event, true);
        return;
      }
      // Clicked to send SMS
      if (classList.includes("sms-btn")) {
        if (!this.showSaveSurgeriesButton) {
          this.$modal.show(SMSToPatient, {
            patientName: event.patient_name,
            patientPassport: event.passport,
            surgId: event.id,
            eventType: "surgery"
          });
          return;
        }
      }
      // Clicked to edit
      if (classList.includes("edit-btn")) {
        this.$router.push("/surg-edit/" + event.id);
        return;
      }
      // Clicked to add docs
      if (classList.includes("doc-btn")) {
        this.$modal.show(AddDocuments, { directUpload: event });
        return;
      }
      // Clicked to send whatsapp
      if (classList.includes("whatsapp-btn")) {
        this.$modal.show(Whatsapp, {
          patientPhone: event.phone
        });
        return;
      }
      // Clicked to send special approval
      if (classList.includes("special-approval-btn")) {
        this.$router.push({
          name: "cellosign-iframe",
          params: { type: "exception-committee", id: event.id }
        });
        return;
      }
      if (!event.background) {
        if (this.$route.name == "surgeries") {
          this.$router.push({ name: "surg-info", params: { id: event.id } });
        } else {
          this.$router.push({ name: "app-info", params: { id: event.id } });
        }
      }
    },
    /**
     * delete block clinc route
     * MOBILE function
     * @param {Object} event
     */
    async deleteBlock(event) {
      try {
        // get block info
        const editBlock = await this.$API.getBlockInfo(event.id);
        if (editBlock.number_of_appointmnts > 0) {
          // if exist appointments on the block can't delete
          this.$modal.show(BlockEditInvalidPop, {
            block: editBlock,
            title: "למחוק"
          });
          window.location.hash = getHash({
            blockId: event.id
          });
          this.hashDataToStorage();
        } else {
          this.$router.push({
            name: "delete-block",
            params: { id: event.id }
          });
        }
        this.SET_INITIAL_TAB("block");
      } catch (error) {
        this.$modal.show(Error);
      }
    },
    /**
     * edit block clinc route
     * MOBILE function
     * @param {Object} event
     */
    editBlock(event) {
      this.$router.push({
        name: "edit-block",
        params: { id: event.id }
      });
      this.SET_INITIAL_TAB("block");
    },
    /**
     * disable block clinc route - "חסוי"
     * MOBILE/DESKTOP function
     * @param {Object} event
     */
    disableBlock(event) {
      this.$modal.show(ConfirmDisableBlock, { block_id: event.id });
    },
    /**
     * active block clinc route - "פעיל"
     * MOBILE/DESKTOP function
     * @param {Object} event
     */
    activateBlock(event) {
      this.$modal.show(ConfirmActivateBlock, { block_id: event.id });
    },
    /**
     * check if has events on specific day
     * MOBILE function
     * @param {Array} events
     * @param {Date} currentDate
     * @returns {bool}
     */
    hasEvents(events, currentDate) {
      for (const event of events) {
        if (compareDate(event.start, currentDate)) {
          return true;
        }
      }
      return false;
    },
    /**
     * trigger when changed room on slider day - surgeries route
     * MOBILE function
     * @param {Object} value - room key
     * update events
     */
    changeRoom(value) {
      this.isRoom = value.room ? true : false;
      // reset events
      this.events = [];
      this.onlyEvents = [];
      for (const block of this.allBlocks) {
        // check if event in same room
        if (block.resourceId != value.room) continue;
        // build event by type
        const tmp = !block.appointment_id
          ? !block.surgery_id
            ? buildBlockEvent(block)
            : buildSurgeryEvent(block)
          : buildAppointmentEvent(block, this.$route.name);
        // if it's not block type push to onlyEvents
        if (!tmp.background) this.onlyEvents.push(tmp);
        // push to events - all events
        this.events.push(tmp);
      }
      // sort by date & time
      this.onlyEvents = this.onlyEvents.sort((a, b) => a.start - b.start);
      setTimeout(() => {
        const eventContainers = document.querySelectorAll(".event-container");
        eventContainers.forEach(c => {
          if (c.parentElement.clientHeight < 80) {
            c.querySelector(".event-title-inner").classList.add("short-surg");
          }
        });
      }, 200);
    },
    /**
     * trigger when view changed and mobile drag events not saved yet
     * MOBILE function
     * @param {Object} event
     * open popup that ask if save the events or continue for view change
     */
    handleDragEventsToSave(event) {
      this.$modal.show(UnsavedChangesAlert, {
        confirmFunc: ev => {
          if (ev) {
            this.UPDATE_EVENTS_TO_SAVE([]);
            this.TOGGLE_MOBISCROLL(false);
            this.viewChange(event, true);
          }
        }
      });
    },
    /**
     * trigger when view changed
     * MOBILE function
     * @param {Object} event
     * update view values
     */
    viewChange(event, forceChange = false) {
      if (
        !forceChange &&
        this.$route.name == "Dashboard" &&
        this.isMobile &&
        this.eventsToSave &&
        this.eventsToSave.length
      ) {
        const isSameView = event.view != this.hashData.view;
        const evDate = this.$moment(event.startDate).format("YYYY-MM-DD");
        const isSameDate = this.$moment(evDate).isSame(
          this.$moment(this.hashData.date)
        );
        const sameChange = !isSameView && isSameDate;
        if (!sameChange) this.handleDragEventsToSave(event);
        this.currentView = this.hashData.view;
        this.currentDate = new Date(this.hashData.date);
        this.$refs.vuecal.switchView(this.hashData.view);
        return;
      }

      this.currentView = event.view;
      if (event.view == "day") {
        const isSame = compareDate(this.currentDate, event.startDate);
        if (!isSame) {
          const index = this.sliderDates.findIndex(
            d => d === this.$moment(this.currentDate).format("DD/MM/YYYY")
          );
          if (this.currentDate > event.startDate) {
            this.dateChange({ date: this.sliderDates[index - 1] });
          } else {
            this.dateChange({ date: this.sliderDates[index + 1] });
          }
        }
        if (this.$route.name != "list" && this.$route.name != "calendar") {
          this.hideTitleBar = true;
        }
      }
      if (event.view == "month" || event.view == "year") {
        this.TOGGLE_MOBISCROLL(false);
        if (event.view == "month" && this.isRoom) this.changeRoom("");
        this.initCalendar(this.activeDoctor.id, new Date(event.startDate));
      }
    },
    /**
     * trigger when slider view changed
     * MOBILE function
     * update view values
     */
    sliderChangeView() {
      if (!this.$refs.vuecal) return (this.currentView = "month");
      this.hideTitleBar = false;
      if (this.$refs.vuecal.currentView == "day") {
        this.$refs.vuecal.switchView("month");
      }
      if (this.$refs.vuecal.currentView == "month") {
        this.$refs.vuecal.switchView("year");
      }
    },
    /**
     * update button active/disable - surgeries route
     * MOBILE/DESKTOP function
     * @param {boolean} newState
     */
    setShowSaveSurgeriesButton(newState) {
      this.showSaveSurgeriesButton = newState;
    },
    /** get event from desktop and set to initCalendar */
    initCalendarDesktop({ currentDate, forceUpdate = false, type = "" }) {
      this.initCalendar(this.activeDoctor.id, currentDate, forceUpdate, type);
    },
    /**
     * updates events
     * @param {String} user_id
     * @param {Date} currentDate
     * @param {bool} forceUpdate
     * @param {String} type - which type of values events update
     * both - events, smallCalEvents
     * small - smallCalEvents
     * "" - events
     */
    async initCalendar(
      user_id,
      currentDate = new Date(),
      forceUpdate = false,
      type = ""
    ) {
      if (!this.activeDoctor || !this.activeDoctor.id) return;
      // Check if day exist in a current range of events
      const existEvents = type == "small" ? this.smallCalEvents : this.events;
      if (existEvents && existEvents.length > 2 && !forceUpdate) {
        const res = isDateInRange(
          existEvents[0].start,
          existEvents[existEvents.length - 1].end,
          currentDate,
          this.$route.name
        );
        if (res) return;
      }
      // get dates range for api call
      let startDate;
      let endDate;
      if (this.currentView == "year" && type != "small") {
        // for year
        const formattedDate = this.$moment(currentDate);
        startDate = this.$moment([formattedDate.year(), 0, 1]).format(
          "YYYY-MM-DD"
        );
        endDate = this.$moment([formattedDate.year() + 1, 0, 30]).format(
          "YYYY-MM-DD"
        );
      } else {
        const formattedDate = this.$moment(currentDate).format("YYYY-MM-DD");
        startDate = this.$moment(formattedDate)
          .subtract(1, "M")
          .format("YYYY-MM-DD");
        endDate = this.$moment(formattedDate)
          .add(this.$route.name == "surgeries" ? 2 : 3, "M")
          .format("YYYY-MM-DD");
      }

      // event type for api call
      let event_type = getEventsType(this.$route.name);
      // calendar - no limit by user api call
      if (this.$route.name == "calendar") user_id = "";
      else if (!user_id) user_id = this.activeDoctor.id;
      await this.$API.cancelAjaxRequest();
      try {
        const events = await this.$API.getFullCalendarEvents(
          this.activeUser.user_id,
          user_id,
          event_type,
          startDate,
          endDate
        );
        if (!events) {
          this.$modal.show(Error);
          return;
        }
        if (type != "small") this.allBlocks = events;
        // build events by type
        let tmpEvents = [];
        let tmpOnlyEvents = [];
        events.map(event => {
          const tmp = !event.appointment_id
            ? !event.surgery_id
              ? buildBlockEvent(event)
              : buildSurgeryEvent(event)
            : buildAppointmentEvent(event, this.$route.name);

          if (tmp) {
            if (!tmp.background) tmpOnlyEvents.push(tmp);
            tmpEvents.push(tmp);
          }
        });
        // if needed update small calendar
        if (type == "both" || type == "small") {
          if (!this.showAppointment && this.isMobile) {
            // for only blocks
            this.smallCalEvents = tmpEvents.filter(e => e.type == "block");
          } else {
            this.smallCalEvents = [...tmpEvents];
          }
        }
        // if needed update calendar / mobile
        if (type == "both" || !type) {
          this.events = [...tmpEvents];
          this.onlyEvents = tmpOnlyEvents.sort((a, b) => a.start - b.start);
          this.SET_MOBISCROLL_EVENTS(this.events);
        }
      } catch (error) {
        this.$modal.show(Error);
      }
    },
    /** updates view & currentDate if date change */
    dateChange(args, getEvents = false) {
      let date;
      if (typeof args.date == "undefined" || args.date == "undefined") {
        date = this.currentDate;
      } else {
        date = this.$moment(args.date, "DD/MM/YYYY");
        this.currentDate = new Date(date);
      }
      this.SET_MOBISCROLL_DATE(this.currentDate);
      if (this.$refs.vuecal)
        this.$refs.vuecal.switchView("day", new Date(date));

      if (getEvents) {
        this.initCalendar(this.activeDoctor.id, this.currentDate);
      }
    },
    /**
     * trigger when click on reschedule surgery
     * @param {Object} event
     * @param {bool} type
     */
    cancelSurg(event, type = false) {
      if (event.tafnit_receipt_no) {
        const { popup, args } = getSurgeryErrorPopup();
        this.$modal.show(popup, { ...args });
        return;
      }

      this.$modal.show(
        CancelPop,
        {
          appointment_id: event.id,
          appDate: "",
          isSurg: true,
          type: type,
          openOnCalendar: true
        },
        {
          clickToClose: true
        }
      );
    },
    /** hide vue cal body */
    hideCalBody() {
      this.hideBody = true;
      this.hideTitleBar = false;
    },
    /** show vue cal body */
    showCalBody() {
      this.hideBody = false;
      this.hideTitleBar = false;
    },
    /** save hash data in storage */
    hashDataToStorage() {
      let hashArr = this.$route.hash.split("&");
      let hashObj = {};
      let hashSpliced = hashArr.slice(1);

      for (let index = 0; index < hashSpliced.length; index++) {
        const element = hashSpliced[index];
        let [key, value] = element.split("=");

        if (!this.$moment(value).isValid() && key == "date") {
          value = this.$moment(new Date()).format("YYYY-MM-DD");
        }
        hashObj[key] = value;
      }
      localStorage.setItem("hashData", JSON.stringify(hashObj));
    }
  },
  computed: {
    ...mapGetters([
      "activeDoctor",
      "activeUser",
      "allRooms",
      "isShowSearch",
      "isSurgSchedule",
      "isMobileDragDrop",
      "eventsToSave",
      "isCalendarPopup"
    ]),
    ...mapState(["doctorRooms"]),
    isSelectedDatePassed() {
      return this.isDatePassed(this.currentDate);
    },
    isCalendar() {
      if (
        (this.$route.name === "calendar" || this.$route.name === "surgeries") &&
        !this.isRoom &&
        this.currentView == "day"
      )
        return false;
      return true;
    },
    isOnlyEvents() {
      if (this.$route.name == "calendar" && this.currentView == "day")
        return true;
      return false;
    },
    timeFrom() {
      if (
        !this.events ||
        !this.events.length ||
        this.currentDate === "Invalid Date"
      ) {
        if (this.$route.name === "surgeries") return 7 * 60;
        return 0 * 60;
      }
      const today = this.$moment(this.currentDate).format("L");
      const evDates = this.events.filter(
        ev => this.$moment(ev.start).format("L") === today
      );
      let hoursStart = evDates.map(d => {
        return parseInt(
          this.$moment(d.start)
            .format("LT")
            .slice(0, -3)
        );
      });
      let min = Math.min(...hoursStart);
      if (!min) return 0 * 60;
      else return (min - 0.5) * 60;
    },
    timeTo() {
      if (
        !this.events ||
        !this.events.length ||
        this.currentDate === "Invalid Date"
      ) {
        return 23 * 60;
      }
      const today = this.$moment(this.currentDate).format("L");
      const evDates = this.events.filter(
        ev => this.$moment(ev.start).format("L") === today
      );
      let hoursEnd = evDates.map(d => {
        return parseInt(
          this.$moment(d.end)
            .format("LT")
            .slice(0, -3)
        );
      });
      let max = Math.max(...hoursEnd);
      if (max === 24) return 24 * 60;
      else return (max + 1) * 60;
    },
    timeStep() {
      if (this.currentView == "day" && this.showAppointment) {
        // for better view when the user have 5 min of appointments
        const selectedDate = this.getDate(this.currentDate);
        const selectedDateEvents = this.events.filter(
          e =>
            e.type === "appointment" &&
            selectedDate === this.getDate(e.start) &&
            this.getDuration(e.start, e.real_end) <= 5
        );
        selectedDateEvents.sort((a, b) => a.start - b.start);
        for (let i = 0; i < selectedDateEvents.length; i++) {
          if (selectedDateEvents[i + 1]) {
            const start = this.$moment(selectedDateEvents[i + 1].start);
            const end = this.$moment(selectedDateEvents[i].real_end);
            if (start.isSame(end)) return 5;
          }
        }
      }
      return 15;
    },
    filteredEvents() {
      if (!this.events) return [];
      let tmp = this.events;

      if (
        this.$route.name == "surgeries" ||
        this.$route.name == "surgeries-list"
      ) {
        tmp = tmp.filter(
          ev =>
            ev.room &&
            ev.room.key !== "surgery_10" &&
            ev.room.key !== "surgery_11"
        );
      }

      if (!this.showAppointment && this.isMobile) {
        return tmp.filter(e => e.type == "block");
      } else if (this.showAppointment && this.isMobile && this.timeStep == 5) {
        return tmp.map(e => {
          if (e.type == "block") return { ...e };
          return { ...e, end: e.real_end, start: e.real_start };
        });
      }
      return tmp;
    },
    isOnlyList() {
      const listRoutes = ["list", "surgeries-list", "surg-app-list"];
      if (listRoutes.includes(this.$route.name) && this.currentView == "day") {
        this.hideCalBody();
        return true;
      }
      this.showCalBody();
      return false;
    },
    activeBlocks() {
      let specialObject = {};
      this.blocks.map(block => {
        let date_start = new Date(block.start);
        let date_end = new Date(block.end);
        let day = parseDay(date_start.getDay() + 1);

        specialObject[day] = {
          from: date_start.getHours() * 60 + date_start.getMinutes(),
          to: date_end.getHours() * 60 + date_end.getMinutes(),
          class: "activeBlock"
        };
      });
      return specialObject;
    },
    sliderDates() {
      let datesArr = [];
      let dates = this.allBlocks.slice().sort((a, b) => a.start - b.start);
      for (const i in dates) {
        let date = this.$moment(new Date(dates[i].start)).format("DD/MM/YYYY");
        if (!datesArr.includes(date)) {
          datesArr.push(date);
        }
      }
      let week = [];
      var index_of_current_day = "";
      for (var key in datesArr) {
        let index = key - 1;
        let days = index + 7;

        for (index; index < days; index++) {
          if (typeof datesArr[index] != "undefined") {
            if (typeof week.find(d => d == datesArr[index]) == "undefined") {
              week.push(datesArr[index]);
            }
          }
        }
      }
      index_of_current_day = week.indexOf(
        this.$moment(this.currentDate).format("DD/MM/YYYY")
      );
      var week_filtered = [];

      if (index_of_current_day < 0) {
        let current_date = this.$moment(this.currentDate).format("DD/MM/YYYY");
        let current_date_arr = current_date.split("/");
        let last_day = 1;
        for (const index in week) {
          let arr = week[index].split("/");
          let index_day = index;
          if (index > 0) {
            index_day = index - 1;
          }
          last_day = week[index_day].split("/")[0];
          if (
            current_date_arr[1] == arr[1] &&
            current_date_arr[0] > last_day &&
            current_date_arr[0] < arr[0]
          ) {
            week.splice(index, 0, current_date);
          }
        }
      }
      index_of_current_day = week.indexOf(
        this.$moment(this.currentDate).format("DD/MM/YYYY")
      );
      for (const index in week) {
        let limit_before = index_of_current_day - 3;
        let limit_after = index_of_current_day + 3;

        if (index >= limit_before && index <= limit_after) {
          week_filtered.push(week[index]);
        }
      }

      return week_filtered;
    },
    isMobile() {
      return window && window.innerWidth < 1200 ? true : false;
    },
    surgeryList() {
      if (
        this.$route.name != "surgeries-list" ||
        !this.events ||
        !this.currentDate
      )
        return [];
      const tody = this.$moment(this.currentDate).format("L");
      const eventsTody = this.events.filter(
        e => e.type === "surgery" && tody === this.$moment(e.start).format("L")
      );
      const sortedTodayEv = eventsTody.sort((a, b) => a.start - b.start);
      return sortedTodayEv;
    }
  },
  beforeDestroy() {
    // Clear the calendar interval to prevent memory leaks
    if (this.calendarInterval) {
      clearInterval(this.calendarInterval);
      this.calendarInterval = null;
    }
    this.$root.$off("rescheduleSurgery");
  },
  components: {
    VueCal,
    DaysSlider,
    Clock,
    Trash,
    Blocked,
    HeaderDesktop,
    MenuDesktop,
    HomeDesktop,
    CalendarDesktop,
    SurgeriesDesktop,
    SurgeryList,
    SurgDotsMenu,
    Scheduler,
    CalendarPopup
  }
};
</script>

<style>
.mobile_only .vuecal__cell:not(.vuecal__cell--has-events) {
  opacity: 0.5;
  pointer-events: none;
}

.vuecal__event.Block.vuecal__event--background {
  background: #32499730;
  z-index: -1;
}

.vuecal__event.Block--private.vuecal__event--background {
  background: #07070830;
  z-index: -1;
}

.vuecal__event {
  background: #fff;
  overflow: initial;
}

.no-events {
  text-align: center;
  font-size: 25px;
  font-weight: bold;
}
</style>
